import React, { useState } from "react";
import { MinusIcon, PlusIcon } from "../../../../app-constants";
import HtmlParser from "react-html-parser";

const FaqComponents = ({ faqs }) => {
  const [openFAQ, setOpenFAQ] = useState(null);

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <>
      {faqs?.map((faq, index) => (
        <div key={index} className="accordion-box">
          <div
            onClick={() => toggleFAQ(index)}
            className={`accordion-item ${openFAQ === index ? "active" : ""}`}
          >
            <h3>{faq.question}</h3>
            {openFAQ === index ? <>{MinusIcon}</> : <>{PlusIcon}</>}
          </div>
          <div
            className={`accordion-body ${
              openFAQ === index ? "faq-answer-visible" : ""
            }`}
          >
            {HtmlParser(faq.answer)}
          </div>
        </div>
      ))}
    </>
  );
};

export default FaqComponents;
